module.exports = __webpack_public_path__ + "static/media/Resume-John-Hellrung.e0468d68.pdf";